import React, { useState } from 'react';
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography
} from '@mui/material';
import CargaDatos from '../components/codificacion/CargaDatos';
import CasosAmbulatorios from '../components/codificacion/CasosAmbulatorios';
import EgresosYCirugias from '../components/codificacion/EgresosYCirugias';

const Codificacion = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Codificación
      </Typography>
      
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mt: 2 }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="codificacion tabs">
          <Tab label="Carga de datos" />
          <Tab label="Casos Ambulatorios" />
          <Tab label="Egresos y Cirugías" />
        </Tabs>
      </Box>

      <Box sx={{ mt: 2 }}>
        {tabValue === 0 && <CargaDatos />}
        {tabValue === 1 && <CasosAmbulatorios />}
        {tabValue === 2 && <EgresosYCirugias />}
      </Box>
    </Box>
  );
};

export default Codificacion;
